export default {
  setLastActivitySavedAt(state) {
    state.lastActivitySavedAt = Date.now()
  }
}
